module.exports = __webpack_public_path__ + "static/mouth_of_grolantor-99c79c6bfaf7686ac79af8f0470c7d33.jpeg";